
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

export type StatusRingGauge =
  | 'none'
  | 'calibrated' // キャリブレーション成功
  | 'success' // 顔方向検知成功
  | 'error';

@Component
export default class FaceDirectionGuide extends Vue {
  @Prop({ type: String, required: true })
  public statusRingGauge!: StatusRingGauge;

  @Prop({ type: Number, required: true })
  public progress!: number;

  private get isPaidy(): boolean {
    return this.$store.getters['auth/isPaidy'];
  }

  private get strokeSize(): number {
    return Math.ceil(this.$store.getters['camera/faceOvalWidth'] / 70);
  }

  private get pathStyle(): { [key: string]: string } {
    // ゲージの開始位置を適切な位置にするための回転の中心
    const cx: number = this.$store.state.camera.displayWidth / 2;
    const cy: number = this.$store.state.camera.displayHeight / 2;
    // 楕円円周の近似式を用いて円周を調べる
    const a: number = this.$store.getters['camera/faceOvalWidth'] / 2;
    const b: number = this.$store.getters['camera/faceOvalHeight'] / 2;
    const length: number = Math.PI * Math.sqrt(2 * (a * a + b * b));
    // 破線を使ったゲージの描画
    return {
      transform: `translate(${cx}px, ${cy}px) rotate(-90deg) translate(-${cx}px, -${cy}px)`,
      opacity: `${this.progress > 0 ? 1.0 : 0.0}`,
      strokeDasharray: `${length}`,
      strokeDashoffset: `${length * (1 - this.progress)}`,
      transitionDuration: this.progress > 0 ? '0.5s' : '0s'
    };
  }
}
